module.exports = __webpack_public_path__ + "column1.png?0d99ddcbca7c1eb256214b0ee51e80ae";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/column1.png
// module id = 338
// module chunks = 0